import { normalizeDomainInput } from "../../lib/hostname";
import { siteRepository } from "../sites/siteRepository";
import { domainRepository } from "./domainRepository";

export const domainService = {
  resolvePublishedSite: (hostname: string) =>
    siteRepository.resolvePublishedSiteByHostname(hostname),

  async getPublishedSite(hostname: string) {
    const resolved =
      await siteRepository.resolvePublishedSiteByHostname(hostname);
    if (!resolved) return null;
    const version = await siteRepository.getVersion(
      resolved.publishedVersionId,
    );
    return { site: resolved.site, version };
  },

  list: (siteId: string) => domainRepository.listForSite(siteId),

  add: (siteId: string, hostname: string) =>
    domainRepository.addDomain(siteId, normalizeDomainInput(hostname)),

  verify: (domainId: string) => domainRepository.verifyDomain(domainId),

  remove: (domainId: string) => domainRepository.removeDomain(domainId),

  setPrimary: (domainId: string) => domainRepository.setPrimary(domainId),

  // Canonical host for a request hostname: the site's primary active custom
  // domain, or null when the hostname doesn't resolve or the site has no
  // primary (the current hostname is then already canonical).
  async canonicalHostname(hostname: string): Promise<string | null> {
    const resolved =
      await siteRepository.resolvePublishedSiteByHostname(hostname);
    if (!resolved) return null;
    return domainRepository.findPrimaryHostname(resolved.site.id);
  },
};
